// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-card{
    border-radius: 0;
}

ion-text{
    position: absolute;
    padding: 0;
    bottom: 5px;
    background: var(--button-a-background);
    color: var(--button-a-text);
    width: 95%;
    font-size: 20px;
    text-align: center;
    left: 50%;
    transform: translateX(-50%);
}`, "",{"version":3,"sources":["webpack://./src/core/pages/section/components/sections-grid/sections-grid.component.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,sCAAsC;IACtC,2BAA2B;IAC3B,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,2BAA2B;AAC/B","sourcesContent":["ion-card{\n    border-radius: 0;\n}\n\nion-text{\n    position: absolute;\n    padding: 0;\n    bottom: 5px;\n    background: var(--button-a-background);\n    color: var(--button-a-text);\n    width: 95%;\n    font-size: 20px;\n    text-align: center;\n    left: 50%;\n    transform: translateX(-50%);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
